import { render, staticRenderFns } from "./HeroSliderButton.vue?vue&type=template&id=40f31e41&"
import script from "./HeroSliderButton.vue?vue&type=script&lang=ts&"
export * from "./HeroSliderButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Button: require('/var/www/tourism-front.visit-hm.ru/releases/28/components/common/Button/index.vue').default})
